import React, { Component } from 'react';
import { withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { connect } from 'react-redux';

import PageHeader from '@/components/PageHeader';
import * as actions from '@/store/actions';
import Newsletters from './Newsletters';
import { Checkbox, Input, CheckboxProps, InputOnChangeData } from 'semantic-ui-react';
import { ListState, Newsletter, NewsletterTemplate, NewsletterEmailTemplate } from '@/types';
import { Dispatch, compose } from 'redux';

import { RootState } from 'MyTypes';

const PAGE_SIZE = 25;

interface Props extends LocalizeContextProps {
    dispatch: Dispatch;
    newslettersTemplates: ListState<NewsletterTemplate>;
    newslettersLog: ListState<Newsletter>;
    newslettersEmailTemplates: ListState<NewsletterEmailTemplate>;
}

class NewsletterLogLoader extends Component<Props> {
    state = {
        ReceiverContains: undefined,
        Sent: true,
    };

    createFetchNewsletterTemplatesAction = (listParams = {}) => {
        const { ReceiverContains, Sent } = this.state;
        return actions.FETCH_NEWSLETTER_TEMPLATES.request({
            Take: PAGE_SIZE,
            ReceiverContains,
            Sent,
            OrderBy: '-Id,-ModifiedDate',
            ...listParams,
        });
    };

    createFetchNewsletterEmailTemplatesAction = (listParams = {}) => {
        const { ReceiverContains, Sent } = this.state;
        return actions.FETCH_NEWSLETTER_TEMPLATES.request({
            Take: PAGE_SIZE,
            ReceiverContains,
            Sent,
            OrderBy: '-Id,-ModifiedDate',
            ...listParams,
        });
    };

    createFetchNewsletterLogAction = (listParams = {}) => {
        const { ReceiverContains, Sent } = this.state;
        return actions.FETCH_NEWSLETTER_LOG.request({
            Take: PAGE_SIZE,
            ReceiverContains,
            Sent,
            OrderBy: '-Id,-ModifiedDate',
            ...listParams,
        });
    };

    handleSearchChange = (e: React.SyntheticEvent, data: InputOnChangeData) => {
        this.setState({ ReceiverContains: data.value }, () => {
            this.props.dispatch(this.createFetchNewsletterTemplatesAction({ Skip: 0 }));
            this.props.dispatch(this.createFetchNewsletterLogAction({ Skip: 0 }));
            this.props.dispatch(this.createFetchNewsletterEmailTemplatesAction({ Skip: 0 }));
        });
    };

    handleSentCheckboxChange = (e: React.SyntheticEvent, data: CheckboxProps) => {
        this.setState({ Sent: data.checked }, () => {
            this.props.dispatch(this.createFetchNewsletterTemplatesAction({ Skip: 0 }));
            this.props.dispatch(this.createFetchNewsletterLogAction({ Skip: 0 }));
            this.props.dispatch(this.createFetchNewsletterEmailTemplatesAction({ Skip: 0 }));
        });
    };

    componentDidMount() {
        this.props.dispatch(this.createFetchNewsletterTemplatesAction({ Skip: 0 }));
        this.props.dispatch(this.createFetchNewsletterLogAction({ Skip: 0 }));
        this.props.dispatch(this.createFetchNewsletterEmailTemplatesAction({ Skip: 0 }));
    }

    render() {
        const { translate } = this.props;
        

        return (
            <>
                <PageHeader
                    breadcrumbs={[
                        { to: '/newsletters', content: translate('newsletters.title') },
                    ]}
                    content={
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                            }}
                        >
                            <Checkbox
                                toggle
                                slider
                                label={translate('newsletterLog.Sent')}
                                style={{ marginRight: 32 }}
                                onChange={this.handleSentCheckboxChange}
                                checked={this.state.Sent}
                            />
                            <Input
                                icon="search"
                                style={{ float: 'right' }}
                                floated="right"
                                onChange={this.handleSearchChange}
                                value={this.state.ReceiverContains}
                            />
                        </div>
                    }
                />
                <Newsletters
                    receiverContains={this.state.ReceiverContains}
                    sent={this.state.Sent} {...this.props}
                    pageSize={PAGE_SIZE}
                    createFetchNewsletterTemplatesAction={this.createFetchNewsletterTemplatesAction}
                    createFetchNewsletterEmailTemplatesAction={this.createFetchNewsletterEmailTemplatesAction}
                    createFetchNewsletterLogAction={this.createFetchNewsletterLogAction}
                />
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        newslettersLog: state.newsletters.log,
        newslettersTemplates: state.newsletters.templates,
        newslettersEmailTemplates: state.newsletters.emailTemplates
    };
};

export default compose<React.ComponentType>(
    connect(mapStateToProps),
    withLocalize
)(NewsletterLogLoader);
